import { Construction } from "lucide-react";
import { useTranslation } from "react-i18next";

export function ModuleDetailPageEmptyState() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center gap-3 py-16 text-muted-foreground">
      <Construction className="size-10 stroke-[1.5]" />
      <p className="text-base font-medium">
        {t("integrations.modules.noDetailPage.title", { defaultValue: "Detail page not yet available" })}
      </p>
      <p className="text-sm">
        {t("integrations.modules.noDetailPage.description", { defaultValue: "This module does not have a detail page configured yet." })}
      </p>
    </div>
  );
}
